import { get, post, remove, put } from "../api_helper";
import * as url from "../url_helper";
const baseURL = process.env.REACT_APP_API_DOTNET_URL;
export const gettingStoredTheme = (payload) =>
  post(baseURL + url.USER_CONFIGURATION, payload);
export const getUserConfiguration = () => get(baseURL + url.USER_CONFIGURATION);
